import { Box, Heading, Text } from '@chakra-ui/react';
import { UdacityIcon } from '@udacity/chakra-uds-icons';

import { ContentContainer } from '~/components/container';
import { SectionHeader } from '~/components/section-header';
import { COPY } from '~/features/ai-marketer/constants';

export function WhyUdacitySection() {
  return (
    <Box as='section' bgGradient='linear(to-r, #0A0B0F 0%, #001D65 100%)' py={{ base: '56px', md: '80px' }}>
      <ContentContainer contentMaxWidth='content-max-width-md'>
        <SectionHeader
          color='blue.300'
          iconSlot={<UdacityIcon color='blue.300' height='18px' width='18px' />}
          subtitle={COPY.whyUdacity.subtitle}
          containerProps={{
            maxWidth: { base: '840px', lg: '920px' },
            mx: 'auto',
          }}
          descriptionSlot={
            <Text
              color={{ base: 'blue.100', md: 'grey.200' }}
              fontSize={{ base: '0.875rem', md: '1rem' }}
              letterSpacing={{ base: '-0.01em', md: 0 }}
              lineHeight={{ base: '1.4', md: '1.5' }}
              maxWidth={{ base: '312px', md: '840px' }}
              mx='auto'
            >
              {COPY.whyUdacity.description}
            </Text>
          }
          titleSlot={
            <Heading
              as='h2'
              color='white'
              letterSpacing='-0.02em'
              size={{ base: 'mobile-heading-3', md: 'mobile-heading-2', lg: 'heading-2' }}
              sx={{ textWrap: 'balance' }}
            >
              {COPY.whyUdacity.title}
            </Heading>
          }
        />
      </ContentContainer>
    </Box>
  );
}
